
export const DevsAPI = {

  selectAll() {
    return $cfg.API.post('/admin/devs/select/all');
  },

  update(dev_id, data) {
    return $cfg.API.put('/admin/devs/' + dev_id, data);
  },

  remove(dev_id) {
    return $cfg.API.delete('/admin/devs/' + dev_id);
  },
  
  setVisibility(dev_id, flag) {
    return $cfg.API.put('/admin/devs/' + dev_id + '/visibility', { flag });
  },

  selectAllComments(dev_id) {
    return $cfg.API.get('/admin/devs/' + dev_id + '/comments/select/all');
  },

  addComment(dev_id, data) {
    return $cfg.API.post('/admin/devs/' + dev_id + '/comment', data);
  },

  removeComment(dev_id, comment_id) {
    return $cfg.API.delete('/admin/devs/' + dev_id + '/comment/' + comment_id);
  },

  transformToUser(dev_id) {
    return $cfg.API.put('/admin/devs/' + dev_id + '/user-transform');
  },

  sendPass(dev_id) {
    return $cfg.API.put('/admin/devs/' + dev_id + '/send-pass');
  },

  selectLatestBilling() {
    return $cfg.API.get('/admin/devs/billing-latest');
  },

  setPayed(dev_id) {
    return $cfg.API.put('/admin/devs/' + dev_id + '/billing-latest/payed');
  },

  syncBillingThisMonth() {
    return $cfg.API.post('/admin/devs/sync-billing');
  },

  createDev(data) {
    return $cfg.API.post('/admin/devs/create', data)
  },

  getDevsExcelWithRates() {
    return $cfg.API.get('/devs/excel/rates', {
      responseType: 'blob'
  });
  },
}
